import topic from '../topic';
export const permAPI = {
  getAllPerms: topic.permTopic + '/get_all_perms',
  getPermsLevel0: topic.permTopic + '/get_perms_level_0',
  getPermsLevel1: topic.permTopic + '/get_perms_level_1',
  getPermsLevel2: topic.permTopic + '/get_perms_level_2',
  addPerm: topic.permTopic + '/add_perm'
};
